import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/ProjectsStyles.css"; // Archivo CSS adaptado
import API_URL from "../../config";

const Projects = () => {
  const [filter, setFilter] = useState("all");
  const [projects, setProjects] = useState([]);

  // Paginación
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Modal
  const [selectedProject, setSelectedProject] = useState(null);
  const [mainImage, setMainImage] = useState("");
  // Para vista ampliada (fullscreen)
  const [fullscreenImage, setFullscreenImage] = useState(null);

  useEffect(() => {
    fetchProjects();
    // eslint-disable-next-line
  }, [currentPage, filter]);

  const fetchProjects = async () => {
    try {
      let statusParam = "all";
      if (filter === "inProgress") {
        statusParam = "En ejecución";
      } else if (filter === "completed") {
        statusParam = "Finalizado";
      }
      const response = await fetch(
        `${API_URL}/api/projects?page=${currentPage}&limit=6&status=${encodeURIComponent(
          statusParam
        )}`
      );
      const json = await response.json();

      setProjects(json.data || []);
      setCurrentPage(json.currentPage || 1);
      setTotalPages(json.totalPages || 1);
    } catch (err) {
      console.error("Error al cargar proyectos:", err);
    }
  };

  const handleFilterChange = (type) => {
    setFilter(type);
    setCurrentPage(1);
  };

  const openModal = (project) => {
    setSelectedProject(project);
    if (project.images && project.images.length > 0) {
      setMainImage(project.images[0]);
    } else {
      setMainImage("");
    }
  };

  const closeModal = () => {
    setSelectedProject(null);
  };

  const changeMainImage = (image) => {
    setMainImage(image);
  };

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const subtitleText = {
    all: "Todos",
    inProgress: "En Ejecución",
    completed: "Finalizados",
  };

  return (
    <main>
      {/* Contenedor del Navbar */}
      <div className="navbar-placeholder-projects"></div>

      {/* Filtros */}
      <section className="container px-1.5 py-3">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6">
            <h1 className="fw-light title-projects">PROYECTOS</h1>
          </div>
          <div className="col-lg-6 col-md-6 d-flex justify-content-end">
            <button
              className="btn btn-filter mx-2"
              onClick={() => handleFilterChange("inProgress")}
            >
              En Ejecución
            </button>
            <button
              className="btn btn-filter mx-2"
              onClick={() => handleFilterChange("completed")}
            >
              Finalizados
            </button>
            <button
              className="btn btn-filter mx-2"
              onClick={() => handleFilterChange("all")}
            >
              Todos
            </button>
          </div>
        </div>
      </section>

      {/* Subtítulo según filtro */}
      <section className="py-0 mt-4 subtitle-section">
        <h2 className="subtitle-projects">
          {subtitleText[filter]}
          <span className="subtitle-divider-projects"></span>
        </h2>
      </section>

      {/* Listado de Proyectos */}
      <div className="album py-5 custom-bg-projects">
        <div className="container">
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
            {projects.map((project) => (
              <div
                key={project.id || project._id}
                className="col"
                onClick={() => openModal(project)}
                style={{ cursor: "pointer" }}
              >
                <div className="card shadow-sm project-card">
                  {project.images && project.images[0] ? (
                    <img
                      src={`${API_URL}/uploads/${project.images[0]}`}
                      className="card-img-top"
                      alt={project.title}
                      style={{ objectFit: "cover", height: "200px" }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "200px",
                        backgroundColor: "#ccc",
                      }}
                    />
                  )}
                  <div className="card-body project-card-body">
                    <h5 className="card-title project-card-title">
                      {project.title}
                    </h5>
                    <p className="card-text project-card-text">
                      <div>
                        <strong>Ciudad:</strong> {project.city}
                      </div>
                      <div>
                        <strong>Estado:</strong> {project.status}
                      </div>
                    </p>
                    <button
                      className="btn btn-details-project btn-sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        openModal(project);
                      }}
                    >
                      Ver Detalles
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Paginación */}
          <div className="my-4 d-flex justify-content-center">
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button
                  className="page-link"
                  onClick={() => goToPage(currentPage - 1)}
                >
                  Anterior
                </button>
              </li>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                (pageNum) => (
                  <li
                    key={pageNum}
                    className={`page-item ${
                      pageNum === currentPage ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => goToPage(pageNum)}
                    >
                      {pageNum}
                    </button>
                  </li>
                )
              )}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => goToPage(currentPage + 1)}
                >
                  Siguiente
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Modal de Detalles */}
      {selectedProject && (
        <div
          className="custom-project-overlay d-flex justify-content-center align-items-center"
          onClick={closeModal}
        >
          <div
            className="custom-project-container"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Carrusel de Imágenes */}
            <div className="custom-project-carousel">
              {selectedProject.images?.length > 0 ? (
                <div
                  id="carouselExampleControls"
                  className="carousel slide"
                  data-bs-ride="carousel"
                >
                  <div className="carousel-inner h-100">
                    {selectedProject.images.map((img, idx) => (
                      <div
                        key={idx}
                        className={`carousel-item ${
                          idx === 0 ? "active" : ""
                        }`}
                        onClick={() =>
                          setFullscreenImage({ img, index: idx })
                        }
                      >
                        <img
                          src={`${API_URL}/uploads/${img}`}
                          className="d-block w-100 h-100"
                          alt={`Imagen ${idx + 1}`}
                          style={{ objectFit: "contain" }}
                        />
                      </div>
                    ))}
                  </div>
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExampleControls"
                    data-bs-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Anterior</span>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExampleControls"
                    data-bs-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="visually-hidden">Siguiente</span>
                  </button>
                </div>
              ) : (
                <div style={{ color: "#fff", textAlign: "center" }}>
                  Sin Imagen
                </div>
              )}
            </div>

            {/* Detalles del Proyecto */}
            <div className="custom-project-details p-4">
              <h3 className="project-title">{selectedProject.title}</h3>
              <hr />
              <p className="project-location">
                <strong>Ubicación:</strong> {selectedProject.location}
              </p>
              <p className="project-description">
                {selectedProject.description}
              </p>
              <ul className="list-unstyled project-info-list">
                <li>
                  <strong>Ciudad:</strong> {selectedProject.city}
                </li>
                <li>
                  <strong>Estado:</strong> {selectedProject.status}
                </li>
              </ul>
            </div>

            {/* Botón de Cerrar */}
            <button
              className="btn-close-project"
              onClick={closeModal}
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {/* Modal de Vista Ampliada */}
      {fullscreenImage && (
        <div
          className="fullscreen-project-overlay"
          onClick={() => setFullscreenImage(null)}
        >
          <div>
            <div className="fullscreen-project-carousel carousel slide h-100">
              <div className="carousel-inner h-100">
                {selectedProject.images.map((img, idx) => (
                  <div
                    key={idx}
                    className={`carousel-item ${
                      fullscreenImage.index === idx ? "active" : ""
                    }`}
                  >
                    <img
                      src={`${API_URL}/uploads/${img}`}
                      className="d-block w-100 h-100"
                      alt={`Imagen ${idx + 1}`}
                      style={{ objectFit: "contain" }}
                    />
                  </div>
                ))}
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target=".fullscreen-project-carousel"
                data-bs-slide="prev"
                onClick={(e) => e.stopPropagation()}
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Anterior</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target=".fullscreen-project-carousel"
                data-bs-slide="next"
                onClick={(e) => e.stopPropagation()}
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Siguiente</span>
              </button>
            </div>

            {/* Botón para cerrar */}
            <button
              className="fullscreen-project-close-btn"
              onClick={() => setFullscreenImage(null)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </main>
  );
};

export default Projects;
